import { ReactElement } from 'react'
import { CloseCircleRegular } from '../../Assets/Icons'
import { Button, Heading, SVG, Text } from '../../Atoms'
import Grid from '../Grid'
import { ConfirmationProps } from './props'
import { StyledErrorConfirmation } from './styles'

/**
 * @name ErrorConfirmation
 * @description Displays a confirmation message with an error icon
 * @param {Array} buttons - Array of buttons
 * @param {ReactElement} icon - Icon to display
 * @param {string} text - Text to display
 * @param {string} headingText - Heading text to display
 */
const ErrorConfirmation = ({
    buttons,
    icon = <SVG src={CloseCircleRegular} />,
    text,
    headingProps,
    headingText,
}: ConfirmationProps): ReactElement => {
    const renderedButtons = buttons?.map((buttonProps, index) => {
        return <Button key={index} {...buttonProps} />
    })

    return (
        <StyledErrorConfirmation>
            {icon}
            {headingText && <Heading {...headingProps}>{headingText}</Heading>}
            {text && (
                <Text size="s" css={{ color: '$neutral400' }}>
                    {text}
                </Text>
            )}
            {renderedButtons && (
                <Grid
                    css={{
                        '@desktop': {
                            gridTemplateColumns: '1fr 1fr',
                        },
                    }}
                    autoFlow={'dense'}
                    gap={'16'}
                >
                    {renderedButtons}
                </Grid>
            )}
        </StyledErrorConfirmation>
    )
}

export default ErrorConfirmation
export { StyledErrorConfirmation }
